
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"62","height":"62","viewBox":"0 0 62 62"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-1231 -150)"}},[_c('rect',{attrs:{"width":"54","height":"54","rx":"8","transform":"translate(1231 150)","fill":"#245389","opacity":".1"}}),_c('path',{attrs:{"d":"M1263.507 209.657h-7.576c-3.768 0-5.587-1.744-5.587-5.344v-29.625c0-3.6 1.838-5.344 5.587-5.344h7.575c3.769 0 5.587 1.744 5.587 5.344v29.625c.001 3.6-1.836 5.344-5.586 5.344zm-7.576-37.5c-2.381 0-2.775.637-2.775 2.531v29.625c0 1.894.394 2.531 2.775 2.531h7.575c2.381 0 2.775-.638 2.775-2.531v-29.625c0-1.894-.394-2.531-2.775-2.531zM1285.069 192.781h-7.576c-3.768 0-5.587-1.743-5.587-5.343v-12.75c0-3.6 1.837-5.344 5.587-5.344h7.575c3.769 0 5.587 1.744 5.587 5.344v12.75c.001 3.6-1.836 5.343-5.586 5.343zm-7.576-20.624c-2.381 0-2.775.637-2.775 2.531v12.75c0 1.894.394 2.531 2.775 2.531h7.575c2.381 0 2.775-.637 2.775-2.531v-12.75c0-1.894-.394-2.531-2.775-2.531z","fill":"#245389"}}),_c('path',{attrs:{"d":"M1285.069 209.657h-7.576c-3.768 0-5.587-1.744-5.587-5.344v-3.375c0-3.6 1.837-5.344 5.587-5.344h7.575c3.769 0 5.587 1.744 5.587 5.344v3.375c.001 3.6-1.836 5.344-5.586 5.344zm-7.576-11.25c-2.381 0-2.775.638-2.775 2.531v3.375c0 1.894.394 2.531 2.775 2.531h7.575c2.381 0 2.775-.637 2.775-2.531v-3.375c0-1.894-.394-2.531-2.775-2.531z","fill":"#f29030"}})])])
          )
        }
      }
    